import * as React from 'react';

function SvgCheckCircle(props) {
  return (
    <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="#38b2a6">
        <path d="M20.12 9.333h-1.428a.982.982 0 00-.789.39l-4.788 6.4-2.169-2.9a.986.986 0 00-.789-.39H8.73c-.198 0-.314.216-.198.372l3.795 5.072a.99.99 0 001.575 0l6.415-8.57c.118-.156.003-.374-.195-.374z" />
        <path d="M14 0C6.269 0 0 6.269 0 14s6.269 14 14 14 14-6.269 14-14S21.731 0 14 0zm0 25.625C7.581 25.625 2.375 20.419 2.375 14S7.581 2.375 14 2.375 25.625 7.581 25.625 14 20.419 25.625 14 25.625z" />
      </g>
    </svg>
  );
}

export default SvgCheckCircle;
